import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { CheckInCircle } from "@faire/web--source/slate/icons/foundation/CheckInCircle";
import { Column, Flex, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var CalendlySection = function() {
    var viewport = useViewport();
    return /*#__PURE__*/ _jsxs(Wrapper, {
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                size: "8x"
            }),
            viewport.isTabletAndAbove ? /*#__PURE__*/ _jsx(CollapsibleRow, {
                justify: "center",
                children: /*#__PURE__*/ _jsxs(Column, {
                    children: [
                        /*#__PURE__*/ _jsx(EducationalTextSection, {}),
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "5x"
                        }),
                        /*#__PURE__*/ _jsx(EducationalCheckPoints, {}),
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "5x"
                        })
                    ]
                })
            }) : /*#__PURE__*/ _jsxs(Column, {
                children: [
                    /*#__PURE__*/ _jsx(EducationalTextSection, {}),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "5x"
                    }),
                    /*#__PURE__*/ _jsx(EducationalCheckPoints, {}),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "5x"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "8x"
            })
        ]
    });
};
var EducationalTextSection = function() {
    return /*#__PURE__*/ _jsxs(EducationalTextWrapper, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: {
                    mobileAndAbove: "displaySSerifRegular",
                    tabletAndAbove: "displayMSerifRegular"
                },
                align: {
                    mobileAndAbove: "left",
                    tabletAndAbove: "center"
                },
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "CXvRDV",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Get one-on-one help from the Faire team to launch your shop"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "3x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subheadingSansRegular",
                align: {
                    mobileAndAbove: "left",
                    tabletAndAbove: "center"
                },
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "fqlxr2",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Your brand partner can provide detailed info and analytics that show what to expect from Faire\u2014and then help you set up your shop."
                        }
                    ]
                })
            })
        ]
    });
};
var EducationalCheckPoints = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    return /*#__PURE__*/ _jsxs(CheckPointWrapper, {
        children: [
            /*#__PURE__*/ _jsx(CheckPointItem, {
                text: strictLocalize({
                    id: "U4Bb97",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Discover your sales estimates and growth potential"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            }),
            /*#__PURE__*/ _jsx(CheckPointItem, {
                text: strictLocalize({
                    id: "Ia4ia9",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Learn how Faire will integrate with your workflow"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            }),
            /*#__PURE__*/ _jsx(CheckPointItem, {
                text: strictLocalize({
                    id: "Phl25O",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Receive 1-on-1 support to set up your shop"
                        }
                    ]
                })
            })
        ]
    });
};
var CheckPointItem = function(param) {
    var text = param.text;
    return /*#__PURE__*/ _jsxs(Row, {
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(CheckInCircle, {
                fontSize: "24px",
                color: Decorative.icon.green
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: 20
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subheadingSansMedium",
                children: text
            })
        ]
    });
};
var Wrapper = styled(Column).withConfig({
    componentId: "sc-e55309bd-0"
})([
    "width:100%;background-color:",
    ";padding:",
    ";border-bottom:solid 1px ",
    ";",
    "{padding:",
    ";}",
    "{padding:",
    ";}"
], Decorative.tint.orange, getSpacing(0, "7x"), Core.border.muted, responsiveMediaQueries.xLargeAndAbove, getSpacing(0, 172), responsiveMediaQueries.mobile, getSpacing(0, "4x"));
// eslint-disable-next-line @faire/prefer-slate-attrs -- move direction to props
var CollapsibleRow = styled(Flex).withConfig({
    componentId: "sc-e55309bd-1"
})([
    "width:100%;height:100%;flex-direction:row;align-items:flex-start;@media (max-width:1280px){flex-direction:column;align-items:center;}"
]);
var EducationalTextWrapper = styled(Column).withConfig({
    componentId: "sc-e55309bd-2"
})([
    "width:600px;",
    "{width:768px;}",
    "{width:100%;min-width:0;}"
], responsiveMediaQueries.xLargeAndAbove, responsiveMediaQueries.mobile);
var CheckPointWrapper = styled(Column).withConfig({
    componentId: "sc-e55309bd-3"
})([
    "width:500px;align-self:center;",
    "{width:100%;min-width:0;}"
], responsiveMediaQueries.mobile);
